// Utility to force refresh of application state
let refreshCallbacks = [];

export const addRefreshCallback = (callback) => {
  refreshCallbacks.push(callback);
};

export const removeRefreshCallback = (callback) => {
  refreshCallbacks = refreshCallbacks.filter((cb) => cb !== callback);
};

export const forceStateRefresh = () => {
  refreshCallbacks.forEach((callback) => {
    try {
      callback();
    } catch (error) {
      console.error("Error in refresh callback:", error);
    }
  });
};

// List of all user-related keys to remove
const userRelatedKeys = [
  "token",
  "user",
  "user.subscriptionPlan",
  "currentOrganization",
  "currentBranch",
  "currency",
  "currencySymbol",
  "currencyDisplay",
  "currencyPosition",
  "dateFormat",
  "numberFormat",
  "sidebarCollapsed",
  "categories",
  "products",
  "vendors",
  "units",
  "services",
  "selectedCountry",
  "language",
  "invoiceCustomThemes",
  "lastUsedInvoiceTheme",
  "editingInvoiceId",
  "lastCurrencyRefresh",
  "lastUsedPaymentTheme",
  "paymentCustomThemes",
  "lastUsedInventoryTheme",
  // Add more as needed from grep results
];

export const clearUserRelatedData = () => {
  userRelatedKeys.forEach((item) => {
    localStorage.removeItem(item);
    sessionStorage.removeItem(item);
  });
};

export const clearAllCachedData = () => {
  // Full clear for all local/session storage
  localStorage.clear();
  sessionStorage.clear();
  forceStateRefresh();
  window.dispatchEvent(new Event("headerContextUpdated"));
};
